"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setTransform = void 0;
var styled_components_1 = require("styled-components");
var setTransform = function (property) { return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  -webkit-transform: ", ";\n  -ms-transform: ", ";\n  transform: ", ";\n"], ["\n  -webkit-transform: ", ";\n  -ms-transform: ", ";\n  transform: ", ";\n"])), property, property, property); };
exports.setTransform = setTransform;
var templateObject_1;
//# sourceMappingURL=transform.js.map